<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" class="demo-form-inline">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" @keyup.enter.native="handleSearch(0)" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code" @keyup.enter.native="handleSearch(0)" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleSearch(0)">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain @click="exportStockWarning">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <h5>总金额：{{ this.total_price }}</h5>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" v-loading="loading" element-loading-text="加载中"
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品代码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" width='80'></el-table-column>
          <el-table-column prop="COUNT" label="库存数量"></el-table-column>
          <el-table-column prop="COMING" label="在途量"></el-table-column>
          <el-table-column prop="OCCUPIED" label="占用量"></el-table-column>
          <el-table-column prop="AVAILABLE" label="可用量"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { queryStockWarning } from '@/assets/api/warehouseManager';
import http from '@/assets/common/http';
import { tryHideFullScreenLoading } from '@/assets/plugin/loading/loading';

export default {
  data() {
    return {
      PAGE_ID: '10504',
      returnVisible: false,
      searchForm: {
        name: '',
      },
      total_price: 0,
      tableData: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      loading: false,
      warehouseList: [],
    };
  },
  mounted() {
    if (this.WMS_STOCKWARNING_CONDITION.CONDITION) {
      this.searchForm = this.WMS_STOCKWARNING_CONDITION.CONDITION;
      this.currentPage = this.WMS_STOCKWARNING_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.handleSearch(0);
  },
  computed: {
    // 上一次的搜索结果和条件
    WMS_STOCKWARNING_CONDITION() {
      return this.$store.state.WMS_STOCKWARNING_CONDITION;
    },
  },
  // created () {
  //     this.queryWare()
  // },
  methods: {
    handleCurrentChange(e) {
      this.currentPage = e;
      this.handleSearch(e - 1);
    },
    // -----------------------------筛选功能
    handleSearch(e) {
      this.currentPage = e + 1;
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: e,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = Number(this.searchForm.code);
      }
      queryStockWarning(params)
        .then((result) => {
          this.loading = false;
          if (result.length !== 0) {
            this.totalCount = result[0].TOTAL_COUNT;
            this.tableData = result[0].OP_ROLE.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
            this.$store.dispatch('SET_WMS_STOCKWARNING_CONDITION', {
              CONDITION: this.searchForm,
              CURRENT_PAGE: this.currentPage,
            });
          }
          if (result[0].TOTAL_WORTH !== '') {
            this.total_price = result[0].TOTAL_WORTH;
          } else {
            this.total_price = 0;
          }
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
      tryHideFullScreenLoading();
      this.loading = true;
    },
    exportStockWarning() {
      const params = {
        SERVICE_ID: '10177',
        OTYPE: 31,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = Number(this.searchForm.code);
      }
      http.post(params).then((res) => {
        window.location.href = res[0].FILE_PATH;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockWarning.vue